module.exports = __webpack_public_path__ + "img/sidearm_logo.15f49004.svg";